const store = {
    namespaced: true,

    state: {
        userIds: [],
        isConferenceEnabled: false
    },

    mutations: {
        ADD_USER: function (state, userId) {
            if (!state.userIds.includes(userId)) {
                state.userIds.push(userId);
            }
        },

        REMOVE_USER: function (state, userId) {
            const index = state.userIds.findIndex(id => id === userId);

            if (index !== -1) {
                state.userIds.splice(index, 1);
            }
        }
    },

    actions: {
        add: function ({commit}, userId) {
            if (!wv.effectController.Participants[userId.toString()]) {
                return;
            }

            commit('ADD_USER', userId);
        },

        remove: function ({commit}, userId) {
            commit('REMOVE_USER', userId);
        },

        updateConferenceStatus: function ({state}, value) {
            state.isConferenceEnabled = value;
        }
    }
};

export default function register(rootStore) {
    rootStore.registerModule('audioConference', store);
}
